import BaseUser from './BaseUserClass'
import Store from '@/store/index'
import _ from 'lodash'

export default class Parent extends BaseUser {
  constructor (rawData = {}) {
    super(rawData)
    this.subscription = !_.isEmpty(rawData ? rawData.subscription : null) ? rawData.subscription : null
    this.theme_body = {
      'pattern': 1,
      'bgColor': '#fde7e5',
      'borderColor': '#f56225'
    }
  }

  plan () {
    if (this.subscription) {
      return Store.getters['subscription/getPlan'](this.subscription.plan_id)
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/models/user/ParentClass.js